import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import { init, create, update } from './grupoFisicoActions';
import PermissaoUsuario from '../auth/permissao';

import List from './grupoFisicoList';
import Form from './grupoFisicoForm';

import GrupoFisicoFormSortable from './grupoFisicoFormSortable';

class GrupoFisico extends Component {
  componentWillMount() {
    this.props.init();
  }

  render() {
    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadGrupoFisico" condicao={true}>
                <TabHeader label="Incluir" icon="plus" target="tabCreate" />
                <TabHeader label="Alterar" icon="pencil-alt" target="tabUpdate" />
                <TabHeader label="Ordenar Grupos" icon="sort" target="tabOrder" />
              </PermissaoUsuario>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
              <TabContent id="tabCreate">
                <Form onSubmit={this.props.create} submitClass="primary" submitLabel="Salvar" premiumLayout={true} />
              </TabContent>
              <TabContent id="tabUpdate">
                <Form
                  onSubmit={this.props.update}
                  readOnly={false}
                  submitClass="primary"
                  submitLabel="Salvar"
                  premiumLayout={true}
                />
              </TabContent>
              <TabContent id="tabOrder">
                <GrupoFisicoFormSortable submitClass="primary" submitLabel="Ordenar" />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

// Mapeia os registros do estado do Redux para as props do componente
const mapDispatchToProps = dispatch => bindActionCreators({ init, create, update }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(GrupoFisico);
